import React from "react";
type Props = {
  /** Número en formato internacional SIN "+" (Chile: 56 + 9 + número) */
  phone?: string; // ej: "56998765432"
  /** Mensaje inicial del chat */
  message?: string;
  /** Posición (px) desde el borde inferior/derecho */
  position?: {
    bottom?: number;
    right?: number;
  };
  /** Tamaño del botón (px del círculo) */
  size?: number;
};
const WhatsAppFloat: React.FC<Props> = ({
  // 👇 CORREGIDO: wa.me NO acepta "+"
  phone = "56953590090",
  message = "Hola Ignacia, quiero vender mi propiedad con MINGA (tarifa fija).",
  position = {
    bottom: 20,
    right: 20
  },
  size = 56
}) => {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  return <a href={href} target="_blank" rel="noopener noreferrer" aria-label="Chatear por WhatsApp con Ignacia (IA de MINGA)" className="fixed z-50 group" style={{
    bottom: position.bottom,
    right: position.right
  }} data-id="element-265">
      <div className="relative" data-id="element-266">
        {/* Tooltip */}
        <div className="absolute bottom-[68px] right-0 translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200 pointer-events-none" data-id="element-267">
          <div className="bg-gray-900 text-white text-xs rounded-md px-3 py-2 shadow-lg" data-id="element-268">
            Chatea con <strong data-id="element-269">Ignacia</strong>
          </div>
        </div>

        {/* Círculo principal */}
        <div className="rounded-full bg-[#25D366] shadow-xl flex items-center justify-center hover:scale-105 active:scale-95 transition-transform" style={{
        width: size,
        height: size
      }} data-id="element-270">
          {/* Logo oficial (Simple Icons) en blanco */}
          <img src="https://cdn.simpleicons.org/whatsapp/ffffff" alt="WhatsApp" className="h-[46%] w-[46%] select-none pointer-events-none" draggable={false} data-id="element-271" />
        </div>

        {/* Pulso suave */}
        <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366]/40" data-id="element-272"></span>
      </div>
    </a>;
};
export default WhatsAppFloat;
export { WhatsAppFloat };